export default __webpack_public_path__ + "static/media/hero-home-page-background-desktop.c1f1579d.png";